import { Injectable } from '@angular/core'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { Observable } from 'rxjs'
import { TaxesEntity } from './taxes.models'

@Injectable({
  providedIn: 'root',
})
export class TaxesApiService extends GbApiService {
  getTaxes(urlName: string): Observable<TaxesEntity[]> {
    const url = `auctions/${urlName}/taxes/`
    return this.get<TaxesEntity[]>(url)
  }

  getTax(urlName: string, taxUuid: string): Observable<TaxesEntity> {
    const url = `auctions/${urlName}/taxes/${taxUuid}/`
    return this.get<TaxesEntity>(url)
  }

  createTax(tax: Partial<TaxesEntity>, urlName: string): Observable<TaxesEntity> {
    tax = { ...tax, auction: urlName }
    const url = `auctions/${urlName}/taxes/`
    return this.post<TaxesEntity>(url, tax)
  }

  updateTax(tax: Partial<TaxesEntity>, urlName: string): Observable<TaxesEntity> {
    tax = { ...tax, auction: urlName }
    const url = `auctions/${urlName}/taxes/${tax.uuid}/`
    return this.patch<TaxesEntity>(url, tax)
  }

  deleteTax(tax: TaxesEntity, urlName: string): Observable<void> {
    tax = { ...tax, auction: urlName }
    const url = `auctions/${urlName}/taxes/${tax.uuid}/`
    return this.delete<void>(url)
  }

  applyTaxToAllItems(urlName: string, taxUuid: string): Observable<void> {
    const url = `auctions/${urlName}/taxes/apply-tax-to-items/`
    return this.post<void>(url, { tax: taxUuid })
  }
}
